<ng-container *ngIf="athlete;else loadingRef">
<app-athlete-season-statistics>

</app-athlete-season-statistics>

<app-athlete-world-ranking-statistics></app-athlete-world-ranking-statistics>
<app-athlete-career-statistics></app-athlete-career-statistics>

</ng-container>
<ng-template #loadingRef>
  <div class="loading-throbber"></div>
</ng-template>
